import {useState} from 'react';
import {useRouteMatch} from 'react-router-dom';
import {Grid} from 'semantic-ui-react';

import GeneralInfo from 'components/Common/GeneralInfo/GeneralInfo';
import Routes from 'components/Common/Routes/Routes';

import styles from './AppCatalogueProject.module.scss';

const AppCatalogueProject = () => {
  const projectType = 'app-catalogue';
  let {
    params: {projectName},
  } = useRouteMatch();

  const [routes, setRoutes] = useState([]);

  const messageWithRoutes = (
    <>
      You are about to delete the project "<strong>{projectName}</strong>" with all its registered
      URLs:
      <ul>
        {routes.map(route => (
          <li key={route}>{route}</li>
        ))}
      </ul>
      This operation can not be undone. Are you sure that you want to proceed? Please note that it
      may take some time for the URL(s) to be available for reuse again.
    </>
  );

  const messageWithoutRoutes = (
    <>
      You are about to delete the project "<strong>{projectName}</strong>". This operation can not
      be undone. Are you sure that you want to proceed?
    </>
  );

  return (
    <>
      <Grid centered>
        <Grid.Column className={styles.AppCatalogueProject}>
          <GeneralInfo
            projectName={projectName}
            projectType={projectType}
            removeProjectMessage={routes.length > 0 ? messageWithRoutes : messageWithoutRoutes}
          />
          <Routes projectType={projectType} projectName={projectName} onRoutesRefresh={setRoutes} />
        </Grid.Column>
      </Grid>
    </>
  );
};

export default AppCatalogueProject;
